import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faSpinner } from '@fortawesome/free-solid-svg-icons';
const PullToRefreshIndicator = ({ pullDistance, refreshing, threshold }) => {
    if (pullDistance === 0 && !refreshing)
        return null;
    const triggered = pullDistance >= threshold;
    return (React.createElement("div", { className: "ptr-indicator", style: {
            transform: `translate3d(0, ${pullDistance}px, 0)`,
            opacity: Math.min(1, pullDistance / threshold)
        }, "aria-hidden": true },
        React.createElement("div", { className: `ptr-icon${refreshing ? ' refreshing' : ''}${triggered ? ' triggered' : ''}` }, refreshing ? (React.createElement(FontAwesomeIcon, { icon: faSpinner, spin: true })) : (React.createElement(FontAwesomeIcon, { icon: faArrowDown })))));
};
export default PullToRefreshIndicator;
